import objectUtils from "@/common/utils/objectUtils";

export const linkTypes = {
  ARTICLE: "article", // get the urls from the article.
  EXPERIENCE: "experience", // get the url from the experience.
  FAVORITE: "favorite", // get the url from the article. interpret index in event as favorite index.
  FUNCTION: "function", // execite a function rather than get a url.
  URL: "url", // the url from the RegistryLinkData.url
  EMPTY: "empty", // the empty link. Allows tag and pause to be passed. Will still register analytic event.
};

export type LinkType = (typeof linkTypes)[keyof typeof linkTypes];

export default class LinkData {
  declare type: string;
  declare data: unknown;
  declare tag: unknown;
  declare pause: boolean;
  // An object of labels; the control bar passes a plain string.
  declare label: Record<string, unknown> | string | undefined;
  declare f: unknown;
  declare url: unknown;

  /*
   * Sets up the link. Data type depends on type.
   * tag - sent to analytics as part of the event.
   * pause - pause the video when selected.
   * label - the label for the cta.
   */
  constructor(
    type: string,
    data?: unknown,
    tag?: unknown,
    pause?: boolean,
    label?: Record<string, unknown> | string,
  ) {
    this.type = type;
    this.data = data;
    this.tag = tag;
    this.pause = pause || false;
    this.label = label;
    switch (type) {
      // if type is ARTICLE or EXPERIENCE, ignore data.
      case linkTypes.ARTICLE:
      case linkTypes.EXPERIENCE:
        break;
      // if type is FUNCTION, data is a function that takes single param that is experienceData
      case linkTypes.FUNCTION:
        if (objectUtils.isFunction(data) === false) {
          console.warn("RegistryLinkData expected a function");
        }
        this.f = data;
        break;
      // if type is URL, then data is a URL string.
      case linkTypes.URL:
        if (objectUtils.isString(data) === false) {
          console.warn("RegistryLinkData expected a string");
        }
        this.url = data;
        break;
    }
  }
}
